import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Recap from './Recap';
import ResultItems from './ResultItems';
import { LoadingState, ResultsHeader } from './partials';
import ErrorState from '@client/components/shared/ErrorState';

const Result = ({
  filters,
  data,
  isLoading,
  error,
  getFilterLabel,
  onResetFilters,
  onRemoveFilter,
  onPageChange,
  onSortChange,
  currentSorting,
  onFiltersFromURL,
}) => {
  const [hideSelectionTags, setHideSelectionTags] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);

  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState error={error} />;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1],
      }}
    >
      <ResultsHeader
        data={data}
        onPageChange={onPageChange}
        filters={filters}
        hideCultures={hideSelectionTags}
        selectedRowKeys={selectedRowKeys}
        showSelectedOnly={showSelectedOnly}
      />
      <Recap
        filters={filters}
        data={data}
        onResetFilters={onResetFilters}
        onRemoveFilter={onRemoveFilter}
        getFilterLabel={getFilterLabel}
        onFiltersFromURL={onFiltersFromURL}
      />
      <ResultItems
        data={data}
        filters={filters}
        onPageChange={onPageChange}
        onSortChange={onSortChange}
        currentSorting={currentSorting}
        hideSelectionTags={hideSelectionTags}
        onHideSelectionTagsChange={setHideSelectionTags}
        selectedRowKeys={selectedRowKeys}
        onSelectedRowKeysChange={setSelectedRowKeys}
        showSelectedOnly={showSelectedOnly}
        onShowSelectedOnlyChange={setShowSelectedOnly}
      />
    </motion.div>
  );
};

export default React.memo(Result);
